<div *appRoles="['Documentos.Crear']">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
    <h1 mat-dialog-title>Nuevo documento</h1>
    <div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
        <app-create-document></app-create-document>
    </div>
</div>
